import { IBureauForm } from '../models/bureaus.model';

export type MeurhBureausModalMode = 'create' | 'edit';

export interface IMeurhBureausModalParams {
    bureau: IBureauForm;
    mode: MeurhBureausModalMode;
}

export class MeurhBureausModalService {
    static $inject = ['$uibModal'];

    constructor(private $uibModal: ng.ui.bootstrap.IModalService) { }

    public open(params: IMeurhBureausModalParams): angular.ui.bootstrap.IModalInstanceService {
        return this.$uibModal.open({
            template: require('html-loader!./bureaus.modal.html'),
            controller: 'MeurhBureausModalController',
            controllerAs: '$ctrl',
            backdrop: 'static',
            resolve: {
                entity: () => params.bureau,
                mode: () => params.mode,
            },
        });
    }
}
